<template>
  <div :class="$style['product-header']">
    <div :class="$style['product-header__left']">
      <h3 :class="$style['product-header__title']">
        {{ product?.title }}
      </h3>
      <div>
        <h3 :class="$style['product-header__subtitle']">
          {{ product?.colorName }}
        </h3>
        <!-- Product price -->
        <div :class="$style['product-header__price']">
          <ProductPrice
            v-if="product?.price"
            :price="product.price" />
        </div>
      </div>
    </div>
    <div :class="$style['product-header__right']">
      <slot name="right" />
    </div>
  </div>
</template>
<script setup>
defineProps({
  loading: {
    type: Boolean,
    default: false
  },
  product: {
    type: [Object, Function, Boolean],
    default: null
  }
})
</script>
<style lang="scss" module>
.product-header {
  display: flex;
  gap: $spacing * 2;
  padding: $spacing * 2;
  width: 100%;
  justify-content: space-between;
  align-items: center;

  @media (max-width: #{$breakpoint-mobile}) {
    padding: $spacing * 1.5;
  }

  &__left {
    display: flex;
    align-items: flex-start;
  }

  &__title {
    margin-right: $spacing * 2;

    @media (max-width: #{$breakpoint-tablet}) {
      display: none;
    }
  }

  &__subtitle {
    color: $grey-dark;
    font-family: $font-base;
    font-size: $font-size;
    line-height: 1;
    font-weight: $font-weight-normal;
    text-transform: none;

    &__flex {
      display: flex;
      justify-content: space-between;
    }

    @media (max-width: #{$breakpoint-tiny}) {
      font-size: $font-size-s;
    }
  }

  &__price {
    font-size: $font-size;

    @media (max-width: #{$breakpoint-tiny}) {
      font-size: $font-size-s;
    }
  }
}
</style>
